import { useForm, Controller } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { useAddSubscriberMutation } from '../../api/subscriberApi';
import { useGetManagerGroupsQuery } from '../../api/groupApi';
import { useToast } from '../../context/ToastContext';
import { errMsg } from '../../utils/errMsg';
import EntityFormPage from '../../components/EntityFormPage/EntityFormPage';
import { CHANNEL_OPTIONS } from '../../utils/channels';
import buttons from '../../styles/shared/buttons.module.css';

export default function SubscriberCreatePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const showToast = useToast();

  const { data: groups } = useGetManagerGroupsQuery();
  const [addSubscriber, { isLoading: isCreating }] = useAddSubscriberMutation();

  const { control, handleSubmit } = useForm({
    defaultValues: { email: '', groupId: location.state?.groupId ?? 'none', channel: 'email' },
  });

  const backTo = location.state?.groupId
    ? `/manager/groups/${location.state.groupId}/subscribers`
    : '/manager/subscribers';

  const onCreate = async (data) => {
    try {
      await addSubscriber({
        email: data.email.trim().toLowerCase(),
        groupId: data.groupId === 'none' ? undefined : data.groupId,
        channel: data.channel,
      }).unwrap();
      showToast('success', 'Subscribers', 'Subscriber added.');
      navigate(backTo);
    } catch (err) {
      showToast('error', 'Subscribers', errMsg(err, 'Could not add subscriber.'));
    }
  };

  return (
    <EntityFormPage title="Add subscriber" backTo={backTo}>
      <form onSubmit={handleSubmit(onCreate)}>
        <Controller
          name="email"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Email</label>
              <InputText id={field.name} type="email" className="w-full mb-3" {...field} />
            </div>
          )}
        />

        <Controller
          name="groupId"
          control={control}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Group</label>
              <Dropdown
                id={field.name}
                value={field.value}
                onChange={(e) => field.onChange(e.value)}
                options={[
                  { label: 'No group', value: 'none' },
                  ...(groups?.map((g) => ({ label: g.name, value: g.id })) ?? []),
                ]}
                className="w-full mb-3"
              />
            </div>
          )}
        />

        <Controller
          name="channel"
          control={control}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Channel</label>
              <Dropdown
                id={field.name}
                value={field.value}
                onChange={(e) => field.onChange(e.value)}
                options={CHANNEL_OPTIONS}
                className="w-full mb-3"
              />
            </div>
          )}
        />

        <Button type="submit" label="Save" className={buttons.saveBtn} loading={isCreating} />
      </form>
    </EntityFormPage>
  );
}
